import React, { useState } from "react";
import { Modal, Radio, Space } from "antd";
import { BANNER_TYPE } from "../../core/constants";

function CreateBannerTypeModal({ visible, onCancel, onConfirm }) {
  const [selectedType, setSelectedType] = useState(BANNER_TYPE.BANNER);

  const handleOk = () => {
    onConfirm(selectedType);
  };

  return (
    <Modal
      title="Chọn loại công cụ truyền thông"
      visible={visible}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Xác nhận"
      cancelText="Hủy bỏ"
      width={420}
      centered
      okButtonProps={{
        style: {
          backgroundColor: "#2246dc",
          borderColor: "#2246dc",
          borderRadius: "6px",
          height: "36px",
          padding: "0 20px",
        },
      }}
      cancelButtonProps={{
        style: {
          borderRadius: "6px",
          height: "36px",
          padding: "0 20px",
        },
      }}
    >
      <div style={{ padding: "16px 0 8px 0" }}>
        <Radio.Group value={selectedType} onChange={(e) => setSelectedType(e.target.value)} style={{ width: "100%" }}>
          <Space direction="vertical" style={{ width: "100%" }} size={12}>
            <Radio
              value={BANNER_TYPE.BANNER}
              style={{
                width: "100%",
                padding: "12px 16px",
                border: selectedType === BANNER_TYPE.BANNER ? "1.5px solid #2246dc" : "1px solid #e0e0e0",
                borderRadius: "8px",
                backgroundColor: selectedType === BANNER_TYPE.BANNER ? "#f0f4fe" : "#ffffff",
              }}
            >
              <span style={{ fontWeight: 500, fontSize: "14px", marginLeft: "8px" }}>Tạo mới Banner</span>
            </Radio>

            <Radio
              value={BANNER_TYPE.POPUP}
              style={{
                width: "100%",
                padding: "12px 16px",
                border: selectedType === BANNER_TYPE.POPUP ? "1.5px solid #2246dc" : "1px solid #e0e0e0",
                borderRadius: "8px",
                backgroundColor: selectedType === BANNER_TYPE.POPUP ? "#f0f4fe" : "#ffffff",
              }}
            >
              <span style={{ fontWeight: 500, fontSize: "14px", marginLeft: "8px" }}>Tạo mới Popup</span>
            </Radio>

            <Radio
              value={BANNER_TYPE.ANNOUNCEMENT_BAR}
              style={{
                width: "100%",
                padding: "12px 16px",
                border: selectedType === BANNER_TYPE.ANNOUNCEMENT_BAR ? "1.5px solid #2246dc" : "1px solid #e0e0e0",
                borderRadius: "8px",
                backgroundColor: selectedType === BANNER_TYPE.ANNOUNCEMENT_BAR ? "#f0f4fe" : "#ffffff",
              }}
            >
              <span style={{ fontWeight: 500, fontSize: "14px", marginLeft: "8px" }}>Tạo mới Announcement Bar</span>
            </Radio>
          </Space>
        </Radio.Group>
      </div>
    </Modal>
  );
}

export default React.memo(CreateBannerTypeModal);
